import { render, staticRenderFns } from "./ReceiptCreditNote.vue?vue&type=template&id=f70e034e&scoped=true&"
import script from "./ReceiptCreditNote.vue?vue&type=script&lang=js&"
export * from "./ReceiptCreditNote.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptCreditNote.vue?vue&type=style&index=0&id=f70e034e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70e034e",
  null
  
)

export default component.exports